export const PURCHASE_HISTORY_REQUESTED = 'PURCHASE_HISTORY_REQUESTED';

/* The proxy request's own lifecycle, as `redux-api-middleware` reports it. The outcome inside a
 * SUCCESS response is what maps onto the resolutions below — a 2xx alone is not an acceptance. */
export const PURCHASE_HISTORY_FETCH_REQUEST = 'PURCHASE_HISTORY_FETCH_REQUEST';
export const PURCHASE_HISTORY_FETCH_SUCCESS = 'PURCHASE_HISTORY_FETCH_SUCCESS';
export const PURCHASE_HISTORY_FETCH_FAILURE = 'PURCHASE_HISTORY_FETCH_FAILURE';

/** Handed off; a live push is expected to follow. */
export const PURCHASE_HISTORY_REQUEST_ACCEPTED = 'PURCHASE_HISTORY_REQUEST_ACCEPTED';
/** Declined, so no push will ever arrive — resolve rather than wait. */
export const PURCHASE_HISTORY_REQUEST_UNAVAILABLE = 'PURCHASE_HISTORY_REQUEST_UNAVAILABLE';
/** Transport error, or a downstream failure or timeout. */
export const PURCHASE_HISTORY_REQUEST_FAILED = 'PURCHASE_HISTORY_REQUEST_FAILED';

/** An accepted live push, having passed every guard. */
export const PURCHASE_HISTORY_EVENT_RECEIVED = 'PURCHASE_HISTORY_EVENT_RECEIVED';

export const PURCHASE_HISTORY_TAKING_LONGER = 'PURCHASE_HISTORY_TAKING_LONGER';
export const PURCHASE_HISTORY_TIMED_OUT = 'PURCHASE_HISTORY_TIMED_OUT';

export const PURCHASE_HISTORY_NOTIFICATION_RAISED = 'PURCHASE_HISTORY_NOTIFICATION_RAISED';
export const PURCHASE_HISTORY_NOTIFICATION_ACTIVATED = 'PURCHASE_HISTORY_NOTIFICATION_ACTIVATED';
export const PURCHASE_HISTORY_NOTIFICATION_DISMISSED = 'PURCHASE_HISTORY_NOTIFICATION_DISMISSED';
